<template>
    <v-toolbar
            class="elevation-0"
            color="primary"
            fixed
            dark
            app
    >
        <v-toolbar-title class="ml-0">
            <v-toolbar-side-icon @click.stop="handleDrawerToggle"></v-toolbar-side-icon>
            <span>{{$t('app.name')}}</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
<!--        <v-btn icon @click="handleFullScreen()">-->
<!--            <v-icon>fullscreen</v-icon>-->
<!--        </v-btn>-->
<!--        <v-menu left offset-y origin="center center" transition="scale-transition">-->
<!--            <v-btn icon large flat slot="activator">-->
<!--                <v-avatar size="30px">-->
<!--                    <v-icon medium>translate</v-icon>-->
<!--                </v-avatar>-->
<!--            </v-btn>-->
<!--            <v-list>-->
<!--                <v-list-tile-->
<!--                        v-for="(language, index) in languages"-->
<!--                        :key="index"-->
<!--                        @click="changeLanguage(language)"-->
<!--                >-->
<!--                    <v-list-tile-title>{{ $t('languages.' + language ) }}</v-list-tile-title>-->
<!--                </v-list-tile>-->
<!--            </v-list>-->
<!--        </v-menu>-->
<!--        <v-menu offset-y-->
<!--                origin="center center"-->
<!--                :nudge-bottom="15"-->
<!--                transaction="scale-transition"-->
<!--                :close-on-content-click="false"-->
<!--        >-->
<!--            <v-btn icon large flat slot="activator">-->
<!--                <template v-if="current_team_id">-->
<!--                    <v-badge overlap bottom color="orange">-->
<!--                        <v-icon slot="badge" dark small>group</v-icon>-->
<!--                        <v-avatar color="red" size="36">-->
<!--                            <span class="white&#45;&#45;text headline">{{getNameAlias(getCurrentTeamName())}}</span>-->
<!--                        </v-avatar>-->
<!--                    </v-badge>-->
<!--                </template>-->
<!--                <template v-else>-->
<!--                    <v-avatar color="green" size="36">-->
<!--                        <v-icon>person</v-icon>-->
<!--                    </v-avatar>-->
<!--                </template>-->

<!--&lt;!&ndash;                <v-badge color="orange" bottom>&ndash;&gt;-->
<!--&lt;!&ndash;                    <v-icon slot="badge" dark small>group</v-icon>&ndash;&gt;-->
<!--&lt;!&ndash;                    <v-avatar size="30px">&ndash;&gt;-->
<!--&lt;!&ndash;                        <v-icon medium>person</v-icon>&ndash;&gt;-->
<!--&lt;!&ndash;                    </v-avatar>&ndash;&gt;-->
<!--&lt;!&ndash;                    <v-avatar color="red" size="30">&ndash;&gt;-->
<!--&lt;!&ndash;                        <span class="white&#45;&#45;text headline">J</span>&ndash;&gt;-->
<!--&lt;!&ndash;                    </v-avatar>&ndash;&gt;-->
<!--&lt;!&ndash;                </v-badge>&ndash;&gt;-->
<!--            </v-btn>-->
<!--            <v-card-->
<!--                    class="mx-auto"-->
<!--                    width="300"-->
<!--            >-->
<!--                <v-card-title class="blue darken-1">-->
<!--                    <template v-if="current_team_id">-->
<!--                        <v-list two-line class="blue darken-1">-->
<!--                            <v-list-tile avatar>-->
<!--                                <v-list-tile-avatar>-->
<!--                                    <v-badge overlap bottom color="orange">-->
<!--                                        <v-icon slot="badge" dark small>group</v-icon>-->
<!--                                        <v-avatar color="red" size="36">-->
<!--                                            <span class="white&#45;&#45;text headline">{{getNameAlias(getCurrentTeamName())}}</span>-->
<!--                                        </v-avatar>-->
<!--                                    </v-badge>-->
<!--                                </v-list-tile-avatar>-->

<!--                                <v-list-tile-content>-->
<!--                                    <v-list-tile-title class="white&#45;&#45;text">{{getCurrentTeamName()}}</v-list-tile-title>-->
<!--                                    <v-list-tile-sub-title class="white&#45;&#45;text">Team</v-list-tile-sub-title>-->
<!--                                </v-list-tile-content>-->
<!--                            </v-list-tile>-->
<!--                        </v-list>-->

<!--                    </template>-->
<!--                    <template v-else>-->
<!--                        <v-list two-line class="blue darken-1">-->
<!--                            <v-list-tile avatar>-->
<!--                                <v-list-tile-avatar>-->
<!--                                    <v-icon class="green white&#45;&#45;text">person</v-icon>-->
<!--                                </v-list-tile-avatar>-->

<!--                                <v-list-tile-content>-->
<!--                                    <v-list-tile-title class="white&#45;&#45;text">{{user_info.name}}</v-list-tile-title>-->
<!--                                    <v-list-tile-sub-title class="white&#45;&#45;text">{{user_info.email}}</v-list-tile-sub-title>-->
<!--                                </v-list-tile-content>-->
<!--                            </v-list-tile>-->
<!--                        </v-list>-->
<!--                    </template>-->

<!--                </v-card-title>-->

<!--                <v-card-text class="pa-0" v-if="teams_data.length">-->
<!--                    <v-list class="team-list-wrapper">-->
<!--                        <v-subheader>-->
<!--                            {{ $t('action.switch_to') }}-->
<!--                        </v-subheader>-->
<!--                        <v-list-tile-->
<!--                                :disabled="!current_team_id"-->
<!--                                @click="switchAccount(0)"-->
<!--                        >-->
<!--                            <v-list-tile-avatar>-->
<!--                                <v-avatar color="green" size="36">-->
<!--                                    <v-icon color="white">person</v-icon>-->
<!--                                </v-avatar>-->
<!--                            </v-list-tile-avatar>-->
<!--                            <v-list-tile-content>-->
<!--                                <v-list-tile-title>{{$t('general.personal_account')}}</v-list-tile-title>-->
<!--                            </v-list-tile-content>-->
<!--                        </v-list-tile>-->
<!--                        <v-list-tile-->
<!--                                v-for="team_data in teams_data"-->
<!--                                :key="team_data.id"-->
<!--                                :disabled="current_team_id == team_data.id"-->
<!--                                @click="switchAccount(team_data.id)"-->
<!--                        >-->
<!--                            <v-list-tile-avatar>-->
<!--                                <v-avatar color="red" size="36">-->
<!--                                    <span class="white&#45;&#45;text headline">{{getNameAlias(team_data.name)}}</span>-->
<!--                                </v-avatar>-->
<!--                            </v-list-tile-avatar>-->

<!--                            <v-list-tile-content>-->
<!--                                <v-list-tile-title v-text="team_data.name"></v-list-tile-title>-->
<!--                            </v-list-tile-content>-->
<!--                        </v-list-tile>-->
<!--                    </v-list>-->
<!--                </v-card-text>-->
<!--            </v-card>-->
<!--        </v-menu>-->
        <v-menu offset-y origin="center center" :nudge-bottom="15">
            <v-btn flat slot="activator">
                <template v-if="current_team_id">
                    <v-badge overlap bottom color="orange">
                        <v-icon slot="badge" dark small>group</v-icon>
                        <v-avatar color="red" size="36">
                            <span class="white--text headline">{{getNameAlias(getCurrentTeamName())}}</span>
                        </v-avatar>
                    </v-badge>
                </template>
                <template v-else>
                    <template v-if="teams_data.length">
                        <v-badge overlap bottom color="orange">
                            <v-icon slot="badge" dark small>group</v-icon>
                            <v-avatar color="green" size="36">
                                <v-icon>person</v-icon>
                            </v-avatar>
                        </v-badge>
                    </template>
                    <template v-else>
                        <v-avatar color="green" size="36">
                            <v-icon>person</v-icon>
                        </v-avatar>
                    </template>

                </template>
                <v-icon class="ml-1" right dark>keyboard_arrow_down</v-icon>
            </v-btn>
            <v-list class="pa-0 user-menu-list-wrapper">
                <template v-if="current_team_id">
                    <v-list-tile avatar class="blue darken-1 py-2">
                        <v-list-tile-avatar>
                            <v-badge overlap bottom color="orange">
                                <v-icon slot="badge" dark small>group</v-icon>
                                <v-avatar color="red" size="36">
                                    <span class="white--text headline">{{getNameAlias(getCurrentTeamName())}}</span>
                                </v-avatar>
                            </v-badge>
                        </v-list-tile-avatar>

                        <v-list-tile-content>
                            <v-list-tile-title class="white--text">{{getCurrentTeamName()}}</v-list-tile-title>
                            <v-list-tile-sub-title class="white--text">Team</v-list-tile-sub-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </template>
                <template v-else>
                    <v-list-tile avatar class="blue darken-1 py-2">
                        <v-list-tile-avatar>
                            <v-icon class="green white--text">person</v-icon>
                        </v-list-tile-avatar>

                        <v-list-tile-content>
                            <v-list-tile-title class="white--text">{{user_info.name}}</v-list-tile-title>
                            <v-list-tile-sub-title class="white--text">{{user_info.email}}</v-list-tile-sub-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </template>
                <v-list-tile v-for="(item,index) in items" :to="!item.href ? { name: item.name } : null" :href="item.href" @click="item.click" ripple="ripple" :disabled="item.disabled" :target="item.target" rel="noopener" :key="index">
                    <v-list-tile-action v-if="item.icon">
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <template v-if="teams_data.length">
                    <v-divider />
                    <v-subheader>
                        {{ $t('action.switch_to') }}
                    </v-subheader>
                    <v-list-tile
                            :disabled="!current_team_id"
                            @click="switchAccount(0)"
                    >
                        <v-list-tile-avatar>
                            <v-avatar color="green" size="36">
                                <v-icon color="white">person</v-icon>
                            </v-avatar>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                            <v-list-tile-title>{{$t('general.personal_account')}}</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile
                            v-for="team_data in teams_data"
                            :key="team_data.id"
                            :disabled="current_team_id == team_data.id"
                            @click="switchAccount(team_data.id)"
                    >
                        <v-list-tile-avatar>
                            <v-avatar color="red" size="36">
                                <span class="white--text headline">{{getNameAlias(team_data.name)}}</span>
                            </v-avatar>
                        </v-list-tile-avatar>

                        <v-list-tile-content>
                            <v-list-tile-title v-text="team_data.name"></v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </template>

            </v-list>
        </v-menu>
    </v-toolbar>
</template>
<script>
    import Utils from '~/utils';
    import {UrlServices} from "~/utils/url-manager";
    import RequestHandler from "~/utils/request-handler";
    // import i18n, {languages} from "~/i18n";
    export default {
        name: 'app-toolbar',
        components: {},
        data: () => ({
            // languages: languages,
            items: [
                {
                    icon: 'account_circle',
                    name: 'account_details',
                    title: getApp.$t('account.account'),
                    click: (e) => { },
                },
                // {
                //     icon: 'feedback',
                //     href: '#',
                //     title: getApp.$t('action.feedback'),
                //     click: () => {
                //         window.open("mailto:name@email.com?subject=Feedback of JitEvent", "_blank");
                //     }
                // },
                {
                    icon: 'exit_to_app',
                    href: '#',
                    title: getApp.$t('login.logout'),
                    click: (e) => {
                        window.getApp.$emit('APP_LOGOUT');
                    }
                }
            ],
        }),
        computed: {
            toolbarColor () {
                return this.$vuetify.options.extra.mainNav;
            },
            current_team_id() {
                return this.$store.state.user_info.current_team_id;
            },
            teams_data() {
                return this.$store.state.teams_data;
            },
            user_info() {
                return this.$store.state.user_info;
            }
        },
        methods: {
            handleDrawerToggle () {
                window.getApp.$emit('APP_DRAWER_TOGGLED');
            },
            handleFullScreen () {
                Utils.toggleFullScreen();
            },
            getCurrentTeamName() {
                let team_name = "";
                let current_team_id = this.current_team_id;
                _.each(this.teams_data, (team_data) => {
                    if(team_data.id == current_team_id){
                        team_name = team_data.name;
                    }
                });
                return team_name;
            },
            getNameAlias(name) {
                let alias = "";
                if(name){
                    alias = name.charAt(0);
                }
                return alias;
            },
            switchAccount(team_id) {
                window.getApp.$emit('APP_START_LOADING');
                RequestHandler.Post(UrlServices.createUrl({name: 'api_switch_account'}), {
                    team_id:  team_id,
                }, {
                    'success': function(data) {
                        location.reload();
                    },
                    'complete': function() {

                    }
                });
            },
            // changeLanguage(language) {
            //     this.$store.dispatch('setLang', language).then(() => {
            //         this.$router.replace({params: {'lang': language}, query: this.$route.query});
            //     });
            // }
        }
    };
</script>

<style>
    a.v-list__tile.v-list__tile--link.v-list__tile--disabled.theme--light {
        background-color: #EEE;
    }

    .team-list-wrapper {
        max-height: calc(100vh - 180px);
        overflow: auto;
    }

    .user-menu-list-wrapper {
        max-height: calc(100vh - 90px);
        overflow: auto;
    }
</style>